import React, { useState, useEffect } from "react";
import { Tabs, Tab, TabPanel, TabList } from "react-web-tabs";

const PubMedSearchResponsiveTabs = (props) => {
    let count = 1
    
    const handleClick =  (event) => {
        let toggle = props.isCheckButtonActive
        props.handleOnTabClickresponsive(event, !toggle)
    }

    return (
        <div>
            <Tabs
                defaultTab={props.selectedTabResponsive.toString()}
                selectedindex={props.selectedTabResponsive}
                onClick={(e) => handleClick(e)}
            >
                <TabList  className="tablist-pubmed-res">
                     <Tab
                        style={{ width: '242px' }}
                        tabFor={props.isTabForId}
                        className={props.isCheckButtonActive ? `${props.width < 1200 ? 'tab-list-item-pubmed-1 tab-list-item-pubmed-active' : 'tab-list-item-pubmed tab-list-item-pubmed-active'}`
                            : `${props.width < 1200 ? 'tab-list-item-pubmed-1' : 'tab-list-item-pubmed'}`
                        }>
                        Highly Responsive
                    </Tab>
                    <Tab
                        style={{ width: '242px' }}
                        tabFor={(Number(props.isTabForId) + count).toString()}
                        className={!props.isCheckButtonActive ? "tab-list-item-pubmed tab-list-item-pubmed-active"
                            : "tab-list-item-pubmed"
                        }>
                        Responsive
                    </Tab>
                </TabList>
            </Tabs>
        </div>
    )
}
export default PubMedSearchResponsiveTabs;